import React from 'react';
import Author from 'services/profissionals/models/author-interface';
import ProfissionalCard from '../ProfissionalCard';
import SliderDefault from 'components/SliderDefault';

import { ProfissionalCardWrapper } from './style';

interface IProfissional {
  profissionals: Array<Author>;
  sliderSettings: any;
  limit?: number;
}

const ProfissionalCarousel: React.FC<IProfissional> = ({
  profissionals,
  sliderSettings,
}) => {
  return (
    <ProfissionalCardWrapper>
      <SliderDefault settings={sliderSettings}>
        {profissionals &&
          profissionals.length &&
          profissionals.map((profissional: Author, index: number) => (
            <ProfissionalCard
              key={index}
              profissional={profissional}
              clickable
            />
          ))}
      </SliderDefault>
    </ProfissionalCardWrapper>
  );
};

export default ProfissionalCarousel;
